import { render, staticRenderFns } from "./DetailPortfolio.vue?vue&type=template&id=625e6b79&scoped=true&"
import script from "./DetailPortfolio.vue?vue&type=script&lang=js&"
export * from "./DetailPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./DetailPortfolio.vue?vue&type=style&index=0&id=625e6b79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e6b79",
  null
  
)

export default component.exports